module.exports = __webpack_public_path__ + "static/img/wawa2.9ea7f33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wawa2.png
// module id = M2Jk
// module chunks = 2